import "./index.css";
import { useTranslation } from "react-i18next";
import { ROUTES } from "@/router";
import { HeaderLink } from "../../../AppLayout/AppHeader/Nav/HeaderLink";
import { useLocation } from "react-router";
import type { IPermission } from "../../../PermissionGuard/constant";
import { Permissions } from "../../../PermissionGuard/constant";
import PermissionGuard from "../../../PermissionGuard";
import { useUserRole } from "@/hooks/useUserRole";
import { useMemo } from "react";

export type INavLink = {
  text: string;
  url: string;
  children?: INavLink[];
  permissions?: IPermission[];
};

export const Nav = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { isSuperAdmin } = useUserRole();
  const hideNavigation = pathname.includes(ROUTES.ONBOARDING);

  const links: INavLink[] = useMemo(() => {
    if (isSuperAdmin) {
      return [
        {
          text: t("label.tenants"),
          url: ROUTES.TENANTS,
        },
      ];
    }

    return [
      {
        text: t("label.projects"),
        url: ROUTES.PROJECTS,
        permissions: [Permissions.Projects.View],
      },
      {
        text: t("label.properties"),
        url: ROUTES.PROPERTIES,
        permissions: [Permissions.Properties.View],
      },
      {
        text: t("label.partners"),
        url: ROUTES.PARTNERS_LENDERS,
        permissions: [Permissions.Companies.View],
        children: [
          {
            text: t("label.contractors"),
            url: ROUTES.PARTNERS_CONTRACTING_COMPANIES,
          },
          {
            text: t("label.lenders"),
            url: ROUTES.PARTNERS_LENDERS,
          },
        ],
      },
      {
        text: t("label.contacts"),
        url: ROUTES.USERS_CLIENTS,
        permissions: [Permissions.Users.View],
        children: [
          {
            text: t("label.clients"),
            url: ROUTES.USERS_CLIENTS,
          },
          {
            text: t("label.inspectors"),
            url: ROUTES.USERS_INSPECTORS,
          },
          {
            text: t("label.contractors"),
            url: ROUTES.USERS_CONTRACTORS,
          },
          {
            text: t("label.admins"),
            url: ROUTES.USERS_ADMINS,
          },
          {
            text: t("label.loan_officers"),
            url: ROUTES.USERS_LOAN_OFFICERS,
          },
        ],
      },
    ];
  }, [isSuperAdmin, t]);

  if (hideNavigation) {
    return null;
  }

  return (
    <nav className="nuco-header__nav">
      {links.map((item) => (
        <PermissionGuard key={item.text} permissions={item.permissions || []}>
          <HeaderLink item={item} />
        </PermissionGuard>
      ))}
    </nav>
  );
};
